import { useState } from "react";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";

import http from "../../../common/http-common";
import * as common from "../../../common/common";
import * as Comp from "../../../common/CommonComponents";

const UserUnlock = (props) => {
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  //#region Modal Show/Hide
  const hideModal = () => {
    props.onHide();
  };
  //#endregion

  //#region Confirm Update Status
  const confirmBtnOnClick = () => {
    UnlockUser(props.editData);
  };

  const UnlockUser = (_data) => {
    let functionName = "";

    try {
      functionName = props.page + UnlockUser.name;

      props.onLoading(true, 
        (_data.LOCK_STATUS === "Not Locked" ? "Locking" : "Unlocking") + 
        " user, please wait...");
      props.onHide();
      const data = {
        USER_ID: _data.USER_ID,
        USER_SHORT_NAME: _data.USER_SHORT_NAME,
        ACCOUNT_LOCK_FLAG: _data.LOCK_STATUS === "Not Locked" ? "Y" : "N",
        UPDATE_ID: userId,
        FROM_SOURCE: { SOURCE: "WEB" /*MODULE_ID: props.module*/ },
      };
      const action = data.ACCOUNT_LOCK_FLAG === "N" ? "unlock" : "lock";

      http
        .put("api/users/UnlockUser", data, { timeout: 5000 })
        .then((response) => {
          toast.success("User is successfully " + action + "ed.");
          props.onReload();
        })
        .catch((err) => {
          toast.error("Failed to " + action + " user. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        })
        .finally(() => {
          props.onLoading(false, "Loading...");
        });
    } catch (err) {
      props.onLoading(false, "Loading...");
      const action = _data.ACCOUNT_LOCK_FLAG === "N" ? "lock" : "unlock";
      toast.error("Failed to " + action + " user. Please try again.");
      common.c_LogWebError(props.page, functionName, err);
    }
  };
  //#endregion

  const message = (
    <>
      Confirm to{" "}
      {props.editData !== null && props.editData.LOCK_STATUS === "Not Locked"
        ? "lock"
        : "unlock"} 
      ? <br /> Username:{" "}
      {<b> {props.editData !== null && props.editData.USER_SHORT_NAME}</b>}
    </>
  );

  return (
    <>
      <Comp.ConfirmModal
        show={props.showHide}
        confirm={true}
        onHide={hideModal}
        onConfirm={confirmBtnOnClick}
      >
        {message}
      </Comp.ConfirmModal>
    </>
  );
};

export default UserUnlock;
